import { render, staticRenderFns } from "./Setari_programator.vue?vue&type=template&id=33185c34&scoped=true&"
import script from "./Setari_programator.vue?vue&type=script&lang=js&"
export * from "./Setari_programator.vue?vue&type=script&lang=js&"
import style0 from "./Setari_programator.vue?vue&type=style&index=0&id=33185c34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33185c34",
  null
  
)

export default component.exports